import * as types from '../constants/actionTypes';

export function closeTask({taskID, status, data} = {}) {
    return { type: types.CLOSE_TASK, taskID, status, data };
}

export function createTask({task, status, data} = {}) {
    return { type: types.CREATE_TASK, task, status, data };
}
export function createTimer({task, logEntry, status, data} = {}) {
    return { type: types.CREATE_TIMER, task, logEntry, status, data };
}
export function deleteFavoriteTask({task, status, data} = {}) {
    return { type: types.DELETE_FAVORITE_TASK, task, status, data };
}
export function deleteTask({taskID, status, data} = {}) {
    return { type: types.DELETE_TASK, taskID, status, data};
}
export function editTask({taskID, task, status, data } = {}) {
    return { type: types.EDIT_TASK, taskID, task, status, data };
}
export function isDeletable({user, status, data} = {}) {
    return { type: types.IS_DELETABLE_TASK, user, status, data};
}
export function loadFavoriteTasks({status, data} = {}) {
    return { type: types.LOAD_FAVORITE_TASKS, status, data };
}
export function loadMostFrequentlyUsedTasks({status, data} = {}) {
    return { type: types.LOAD_MOST_FREQUENTLY_USED_TASKS, status, data };
}
export function loadOtherTasks({status, data} = {}) {
    return { type: types.LOAD_OTHER_TASKS, status, data };
}
export function loadRecentlyAssignedTasks({status, data} = {}) {
    return { type: types.LOAD_RECENTLY_ASSIGNED_TASKS, status, data };
}
export function loadTasks({status, data} = {}) {
    return { type: types.LOAD_TASKS, status, data };
}
export function loadTasksAssignableToUserByProject({userID, projectID, status, data} = {}) {
    return {type: types.LOAD_TASKS_ASSIGNABLE_TO_USER_BY_PROJECT, userID, projectID, status, data };
}
export function loadTasksByProject({projectID, status, data} = {}) {
    return { type: types.LOAD_TASKS_BY_PROJECT, projectID, status, data };
}
export function loadTasksByUser({user, status, data} = {}) {
    return { type: types.LOAD_TASKS_BY_USER, user, status, data };
}
export function pmLoadAllTasks({status, data} = {}) {
    return { type: types.PM_LOAD_ALL_TASKS, status, data };
}
export function pmoLoadAllTasks({status, data} = {}) {
    return { type: types.PMO_LOAD_ALL_TASKS, status, data };
}
export function reopenTask({taskID, status, data} = {}) {
    return { type: types.REOPEN_TASK, taskID, status, data };
}
export function setColorTask({task, status, data} = {}) {
    return { type: types.SET_COLOR_TASK, task, status, data };
}
export function setFavoriteTask({task, status, data} = {}) {
    return { type: types.SET_FAVORITE_TASK, task, status, data };
}
export function setLoadingFlagForTaskState() {
    return { type: types.SET_LOADING_FLAG_FOR_TASK_STATE };
}
export function setSelectedTask(task) {
    return { type: types.SET_SELECTED_TASK, task };
}



/** WEBPACK FOOTER **
 ** ./src/app/constants/taskActions.js
 **/